import { Outlet } from 'react-router';
import Logo from '../../assets/icons/logo-b.svg';
import './PublicLayout.scss';

function PublicLayout({ logo = true }: { logo?: boolean }) {
  return (
    <>
      {logo && <div className='public-container'>
        <div className='main-logo'>
          <img src={Logo} alt='main logo' />
        </div>
        <Outlet />
      </div>}
      {!logo && <Outlet />}
    </>
  );
}

export default PublicLayout;
